import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  isOpen: boolean;
  forceCollapsed: boolean;
  previousState: boolean | null;
  // ホームの履歴と全画面チャットのように、複数の画面要素が同時に縮小を求めることがある。
  // すべての要求が解除されるまで縮小を保つため、要求の数を数える。
  collapseRequests: number;
}

const initialState: SidebarState = {
  isOpen: true,
  forceCollapsed: false,
  previousState: null,
  collapseRequests: 0,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    // true / false は必ず対で呼ぶ（縮小を求めた側が、不要になったら解除する）。
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        // 閉じる前に現在の状態を保存
        if (state.collapseRequests === 0) {
          state.previousState = state.isOpen;
        }
        state.collapseRequests += 1;
        state.forceCollapsed = true;
        state.isOpen = false;
        return;
      }

      if (state.collapseRequests === 0) return;
      state.collapseRequests -= 1;
      if (state.collapseRequests > 0) return;

      // 元の状態に戻す
      state.forceCollapsed = false;
      if (state.previousState !== null) {
        state.isOpen = state.previousState;
        state.previousState = null;
      }
    },
  },
});

export const { setSidebarOpen, setSidebarCollapsed } = sidebarSlice.actions;
export default sidebarSlice.reducer;
